<template>
  <div>
    <form>
      <!-- ///responsável -->
      <div class="">
        <div class="row">
          <div class="col-md-1" v-if="data.id">
            <form-group-image
              :url="url + 'image/render/thumb/' + data.CarImages[0].imageId"
              :value="data.CarImages[0].imageURL"
              img-type="square"
            />
          </div>

          <!-- <b-modal id="image-modal" title="Todas as Imagens">
            <div>
              <img
                v-for="image in data.CarImages"
                :src="url + 'image/render/thumb/' + image.id"
                :key="image.id"
              />
            </div>
          </b-modal> -->
          <div class="col-md-2">
            <fg-input
              class="clean"
              type="text"
              label="Código"
              placeholder="Código"
              v-model="data.code"
              v-bind:readonly="readonly"
            />
          </div>
          <div class="col-md-5">
            <fg-input
              class="clean"
              type="text"
              label="Titulo"
              placeholder="Titulo"
              v-model="data.name"
              v-bind:readonly="readonly"
            />
          </div>

          <div class="col-md-3">
            <fg-input
              class="clean"
              type="text"
              label="Condição do veículo"
              placeholder="Condição do veículo"
              v-model="data.conservationState"
              v-bind:readonly="readonly"
            />
          </div>

          <div class="col-md-2">
            <fg-input
              class="clean"
              type="text"
              label="Quilometragem/Km"
              placeholder="Km"
              v-model="data.mileage"
              v-bind:readonly="readonly"
            />
          </div>

          <div class="col-md-2">
            <fg-input
              class="clean"
              type="text"
              label="Ano"
              placeholder="Ano"
              v-model="data.year"
              v-bind:readonly="readonly"
            />
          </div>

          <div class="col-md-3">
            <fg-input
              class="clean"
              type="text"
              label="Valor"
              placeholder="Valor"
              v-on:input="format"
              v-model="data.formattedValueCentavos"
              v-bind:readonly="readonly"
            />
          </div>

          <!-- <div class="col-md-3">
            <fg-input
              class="clean"
              type="text"
              label="Medida liquida"
              placeholder="Medida liquida"
              v-model="data.netMeasures"
              v-bind:readonly="readonly"
            />
          </div> -->

          <!-- <div class="col-md-4">
            <fg-input
              class="clean"
              type="text"
              label="Medida bruta"
              placeholder="Medida bruta"
              v-model="data.grossMeasures"
              v-bind:readonly="readonly"
            />
          </div> -->
        </div>
      </div>
    </form>
  </div>
</template>
<script>
import { mapActions, mapState, mapGetters } from "vuex";
import moment from "moment";
import formGroupImage from "src/components/UIComponents/Inputs/formGroupImage.vue";
import { NAMES } from "../../../config";

export default {
  name: "car-form",
  components: {
    formGroupImage,
  },

  props: {
    data: {
      type: Object,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    event: {
      type: String,
      default: "",
    },
    url: {
      type: String,
      default: NAMES.fullUrl,
    },
  },

  computed: {
    ...mapState({
      // s
    }),
  },

  methods: {
    ...mapActions(["getMaterialList"]),
    ...mapGetters({
      sidebarFlag: "sidebarFlag",
    }),
    unlock() {
      if (this.sidebarFlag() === "ADMIN") {
        this.localReadonly = !this.localReadonly;
      } else {
        this.localReadonly = true;
      }
    },

    openImageModal(images) {
      this.modalImages = images; // Define as imagens para exibir no modal
      this.$bvModal.show("image-modal");
    },

    formatDate(date) {
      return moment
        .utc(date)
        .utcOffset(-180)
        .format("D/M/YYYY H:mm:ss");
    },

    format: function(sValue) {
      this.data.formattedMarkValueCentavos = parseInt(("" + sValue).onlyNumber()).int2Money();

      this.data.markValueCentavos = this.data.formattedMarkValueCentavos
        .replace("R$", "")
        .replace(",", "")
        .replace(".", "")
        .replace(" ", "");

      this.$nextTick(() => {});
    },
  },

  created() {
    this.$on("execute", () => {
      this.$parent.$emit(this.event, this.data);
    });
  },
  data() {
    return {
      localReadonly: false,
      isPerfect: [
        {
          value: true,
          name: "Sim",
        },
        {
          value: false,
          name: "Não",
        },
      ],
    };
  },
};
</script>
<style scoped lang="scss">
label.stronger {
  font-weight: bold;
  color: black;
}

.stronger {
  font-weight: bold;
  color: black;
  margin: 15px 0 0 0 !important;
}

p.subject {
  color: #9c9c9c;
}
</style>




// WEBPACK FOOTER //
// src/components/UIComponents/Forms/CarForm.vue